import React from 'react';
import {
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  FormFeedback,
} from 'reactstrap';

/*
 * Rp. currency input bound to a { displayValue, valid, invalid, isFree }
 * field. Matches the legacy per-price inputs: only Normal Price rendered a
 * FormFeedback, and Registration Fee is permanently disabled.
 */
const CurrencyField = ({
  label,
  title,
  field,
  onChange,
  showFeedback = false,
  disabled = false,
}) => {
  return (
    <FormGroup>
      <Label for={`form${label}`} className="text-gray font-weight-bold">
        {title}
      </Label>
      <InputGroup>
        <InputGroupAddon addonType="prepend">Rp.</InputGroupAddon>
        <Input
          type="text"
          valid={field.valid}
          invalid={field.invalid}
          disabled={disabled || field.isFree}
          value={field.displayValue}
          onChange={onChange}
        />
      </InputGroup>
      {showFeedback && (
        <FormFeedback invalid="true">*{field.error}</FormFeedback>
      )}
    </FormGroup>
  );
};

export default CurrencyField;
